import React from 'react';

export const MenuIcon = props =>
  <svg width="19" viewBox="0 0 19 19" {...props}>
    <g stroke="none" strokeWidth="1" fillRule="nonzero">
      <path d="M3.2,5 L15.8,5 C15.9104569,5 16,5.08954305 16,5.2 L16,5.8 C16,5.91045695 15.9104569,6 15.8,6 L3.2,6 C3.08954305,6 3,5.91045695 3,5.8 L3,5.2 L3,5.2 C3,5.08954305 3.08954305,5 3.2,5 L3.2,5 Z M3.2,13 L15.8,13 C15.9104569,13 16,13.0895431 16,13.2 L16,13.8 C16,13.9104569 15.9104569,14 15.8,14 L3.2,14 C3.08954305,14 3,13.9104569 3,13.8 L3,13.2 C3,13.0895431 3.08954305,13 3.2,13 L3.2,13 Z M3.2,9 L15.8,9 C15.9104569,9 16,9.08954305 16,9.2 L16,9.8 C16,9.91045695 15.9104569,10 15.8,10 L3.2,10 C3.08954305,10 3,9.91045695 3,9.8 L3,9.2 C3,9.08954305 3.08954305,9 3.2,9 L3.2,9 Z"/>
    </g>
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/menu-icon.js